import { computed } from 'vue';
import type { RouteLocationNormalizedLoaded } from 'vue-router';
import type {
  DinhMucCoDinhFormConfig,
  DinhMucCoDinhFormMode,
} from '../types';

const CREATE_CONFIG: DinhMucCoDinhFormConfig = {
  mode: 'create',
  pageTitle: 'Tạo mới định mức cố định',
  documentTitleSuffix: 'Định mức cố định',
  breadcrumbActionLabel: 'Tạo mới',
  submitCreateMessage: 'Tạo mới thành công',
  submitUpdateMessage: '',
  confirmCreateTitle: 'Tạo mới đ/mức với những thông tin đã nhập?',
  confirmUpdateTitle: '',
};

const EDIT_CONFIG: DinhMucCoDinhFormConfig = {
  mode: 'edit',
  pageTitle: 'Chỉnh sửa định mức cố định',
  documentTitleSuffix: 'Định mức cố định',
  breadcrumbActionLabel: 'Chỉnh sửa',
  submitCreateMessage: '',
  submitUpdateMessage: 'Cập nhật thành công',
  confirmCreateTitle: '',
  confirmUpdateTitle: 'Chỉnh sửa đ/mức với những thông tin đã nhập?',
};

export function resolveDinhMucCoDinhFormConfig(
  route: RouteLocationNormalizedLoaded
): DinhMucCoDinhFormConfig {
  const routeName = route.name?.toString() ?? '';

  if (routeName.includes('chinh-sua') || routeName.includes('cap-nhat')) {
    return EDIT_CONFIG;
  }

  if (route.params.id) {
    return EDIT_CONFIG;
  }

  return CREATE_CONFIG;
}

export function useDinhMucCoDinhFormMode(route: RouteLocationNormalizedLoaded) {
  const formConfig = computed(() => resolveDinhMucCoDinhFormConfig(route));

  const isCreating = computed(() => formConfig.value.mode === 'create');
  const isEditing = computed(() => formConfig.value.mode === 'edit');

  return {
    formConfig,
    isCreating,
    isEditing,
  };
}

export function isDinhMucCoDinhEditMode(mode: DinhMucCoDinhFormMode) {
  return mode === 'edit';
}
